import { EventEmitter, Injectable } from "@angular/core";


// Behandelt die Sichtbarkeit der Searchbar

@Injectable()
export class SearchbarService {
	constructor() {
	}

	public searchTerm = "";
	private headerHeight = 0;
	public optionalCategoryGroupFilter: number;
	public lastSearchResultTerm: string;
	private static insertIntoSearchbar: EventEmitter<string> = new EventEmitter<string>();
	private static searchBarMark = new EventEmitter();
	private static searching = new EventEmitter<boolean>();

	getHeaderHeight(): number {
		return this.headerHeight;
	}

	setHeaderHeight(height: number) {
		this.headerHeight = height;
	}

	getSearchInsert(): EventEmitter<string> {
		return SearchbarService.insertIntoSearchbar;
	}

	insertSearchInput(term?: string) {
		SearchbarService.insertIntoSearchbar.emit(term);
	}

	getSearchMark(): EventEmitter<void> {
		return SearchbarService.searchBarMark;
	}

	markSearchbarText() {
		SearchbarService.searchBarMark.emit();
	}

	setSearching(isSearching: boolean) {
		SearchbarService.searching.emit(isSearching);
	}

	getSearching(): EventEmitter<boolean> {
		return SearchbarService.searching;
	}
}
